import React from 'react';
import { EmptyList } from 'modules/common';
import { Link } from 'react-router-dom';

export function EmptyPageList({ activeTabKey, profileCandidate }) {
  if (activeTabKey === 'video') {
    return (
      <EmptyList
        text="No Video Pages"
        description="Create a video page to start raising money."
        buttonText="Create Video Page"
        icon="video"
        iconColor="green"
        name="video"
        as={Link}
        to={`/${profileCandidate.organization_revv_uid}/pages/new/video`}
      />
    );
  }
  if (activeTabKey === 'high_dollar') {
    return (
      <EmptyList
        text="No High Dollar Pages"
        description="Create a high dollar page to start raising money."
        buttonText="Create High Dollar Page"
        icon="donate"
        iconColor="gold"
        name="high-dollar"
        as={Link}
        to={`/${profileCandidate.organization_revv_uid}/pages/new/high-dollar`}
      />
    );
  }

  if (activeTabKey === 'petition') {
    return (
      <EmptyList
        text="No Petition Pages"
        description="Create a petition page to start raising money."
        buttonText="Create Petition Page"
        icon="pen-nib"
        iconColor="gray"
        name="petition"
        as={Link}
        to={`/${profileCandidate.organization_revv_uid}/pages/new/petition`}
      />
    );
  }

  if (activeTabKey === 'conduit') {
    return (
      <EmptyList
        text="No Donation Pages"
        description="Create a donation page to start raising money."
        buttonText="Create Donation Page"
        icon="donate"
        iconColor="green"
        name="donation"
        as={Link}
        to={`/${profileCandidate.organization_revv_uid}/pages/new/donation`}
      />
    );
  }

  return (
    <EmptyList
      text="No Pages"
      description="Create a donation page to start raising money."
      buttonText="Create Donation Page"
      icon="donate"
      iconColor="green"
      name="donation"
      as={Link}
      to={`/${profileCandidate.organization_revv_uid}/pages/new/donation`}
    />
  );
}
